import { render, staticRenderFns } from "./guest-check-in-template-selection.vue?vue&type=template&id=70060660&scoped=true&"
import script from "./guest-check-in-template-selection.vue?vue&type=script&lang=js&"
export * from "./guest-check-in-template-selection.vue?vue&type=script&lang=js&"
import style0 from "./guest-check-in-template-selection.vue?vue&type=style&index=0&id=70060660&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70060660",
  null
  
)

export default component.exports